import { render, staticRenderFns } from "./WaitActivity.vue?vue&type=template&id=12a72ec0&scoped=true&"
import script from "./WaitActivity.vue?vue&type=script&lang=js&"
export * from "./WaitActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=12a72ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a72ec0",
  null
  
)

export default component.exports